import { url } from '@api-config';
import { app_json_content_type } from 'Api/utils/getAuthHeaders';
import { initAuthToken } from '../initAuthToken';

export type TEOAuthLoginArgs = {
  userName: string;
  tenantId: string;
  isDefaultTenantSelected: boolean;
  oauthToken: string;
  refreshToken: string;
  accessToken: string;
};

/**
 * Makes login request for SSO & calls initAuthToken to initialize the token in local or session storage
 * @param TEOAuthLoginArgs
 */
export const EOAuthLoginRequest = async ({
  oauthToken,
  refreshToken,
  accessToken,
  userName,
  tenantId,
  isDefaultTenantSelected,
}: TEOAuthLoginArgs) => {
  const res = await fetch(url.ssoOauthLogin, {
    method: 'POST',
    headers: {
      'Content-Type': app_json_content_type,
    },
    body: JSON.stringify({
      oauthToken,
      refreshToken,
      accessToken,
      userName,
      tenantId,
      defaultTenant: isDefaultTenantSelected,
    }),
  });

  initAuthToken(res, true, refreshToken);
};
